var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemix = function SvgRemix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.333 4.74c.206-.992.31-1.488.111-1.68a.5.5 0 0 0-.216-.123c-.266-.072-.64.27-1.385.956l-.428.393c-.424.39-.637.584-.893.644a1 1 0 0 1-.256.025c-.263-.008-.51-.157-1.002-.456l-.262-.16c-.89-.538-1.334-.808-1.582-.682a.5.5 0 0 0-.188.166c-.155.23.057.705.481 1.654l.242.54c.226.505.339.758.319 1.012a1 1 0 0 1-.05.244c-.083.242-.287.43-.695.804l-.585.537c-.709.651-1.063.977-1.019 1.245a.5.5 0 0 0 .1.225c.166.213.646.172 1.606.09l.726-.063c.55-.048.826-.071 1.06.03q.113.051.213.128c.2.156.31.41.532.917l.117.27c.402.922.602 1.383.874 1.425a.5.5 0 0 0 .248-.024c.258-.094.366-.585.582-1.567l.088-.397c.12-.552.182-.828.353-1.022a1 1 0 0 1 .19-.167c.215-.145.497-.17 1.06-.218l.639-.055c.977-.084 1.466-.126 1.593-.367a.5.5 0 0 0 .058-.24c-.004-.273-.42-.533-1.252-1.053l-.715-.446c-.456-.285-.684-.427-.809-.642a1 1 0 0 1-.095-.224c-.069-.238-.014-.502.095-1.028z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.406 13.794-2.193-2.268-1.097-1.134-.549-.567"
  })));
};
export default SvgRemix;